import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { User } from '../User';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { AuthenticationService } from '../authentication.service';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { ApiService } from '../api.service';
import 'rxjs/add/operator/map';
import { AlertService } from '../alert.service';
import { ModalDirective } from 'angular-bootstrap-md';
import { Item, ITEMS } from '../rating-data';
import {CookieService} from 'ngx-cookie-service';
declare function setCookie(cookieValue): any;
declare function getDocumentCookies(): any;
declare function readCookie(name): any;
declare function deleteAllCookies(): any;

class signUpUserObj {
  fName: string = ""; 
  lName: string = "";
  gender: number = 1; 
  signUpType: "generic";
  mobile: string = "";
  email: string = "";
  password: string = "";
  constructor(values: Object = {}) {
    //Constructor initialization
    Object.assign(this, values);
  }
}

class signinUsrObj {
  username: string = "";
  password: string = "";
  constructor(values: Object = {}) {
    //Constructor initialization
    Object.assign(this, values);
  }
}


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @ViewChild('basicModal') basicModal: ModalDirective;
  @ViewChild('OTPModal') OTPModal: ModalDirective;
  @ViewChild('forgotPasswordModal') forgotPasswordModal: ModalDirective;
  @ViewChild('RatingModal') RatingModal: ModalDirective;
  @ViewChild('loginForm') form: any;
  show1: boolean = false;
  show2: boolean = true;
  fName:string ="";
  public show: boolean = true;
  public buttonName: any = 'Sign Up';

  loginAlert: string;
  loginError: boolean = false;
 
  buttonText: string;  // to show the message in login/signup buton
  private debugData: Boolean = false;  // to show and hide the data in console log
  private user: User;  // to store the values of user object return from server
  userSignUpData: signUpUserObj; // to store the values of signup form
  userSigninData: signinUsrObj; // to store values of signin form data
  otpErrorMsg: string = ""; // to display the error msg on otp popup
  emailResetMsg: string = ""; // to display the error msg in email reset popup
  SignUpmsg: string = ""; // to display the signup msg in signup form html
  SignInmsg: string = ""; // to display the error msg in sign in form html

  toggle() {
    this.show1 = !this.show1;
  }



  toggleH() {
    this.show = !this.show;
    // CHANGE THE NAME OF THE BUTTON.
    if (this.show)
      this.buttonName = "Sign Up";
    else
      this.buttonName = "Login";
  }
  radioSel: any;
  radioSelected: string;
  radioSelectedString: string;
  itemsList: Item[] = ITEMS;
  public getCompDataDetail: any = [];
  ratingErrMsg: string = ""; //show rating error message
  constructor(private httpClient: HttpClient, private route: ActivatedRoute, private router: Router,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService, private authenticationservice: AuthenticationService,
    private alertService: AlertService, private apiService: ApiService,private cookie:CookieService) {

    this.initCustData();
    this.userSigninData = new signinUsrObj();
    this.userSignUpData = new signUpUserObj();
    if (this.debugData == true) {
      //    console.log(this.userSignUpData);
    }

    this.itemsList = ITEMS;
    this.radioSelected = "Okay";
    this.getSelecteditem();
  }

  private checkCookies(): string {
     console.log("in checkCookies......");
        let cookiesValue;
        
        getDocumentCookies();
        cookiesValue = readCookie('user');
       

        if ((cookiesValue == null) || (cookiesValue == "")) {
          return null;
        } else {
          return cookiesValue;
        }
  }

  ngOnInit() {
   

  console.log("in ngOnInit");
    var cookiesValue = this.checkCookies();

   if((cookiesValue != null) && ( cookiesValue != "")) {
    console.log("*******cookiesValue********");
    console.log(cookiesValue);
    this.cookieLogin(cookiesValue);
   } 

    this.uName = this.apiService.getFromLocalData("Name")
    console.log("**********cookie***********");
    
    // getDocumentCookies();
    // var value = readCookie('user56');
    // var value1 = readCookie('user89');
    // console.log("***********value*************");
    // console.log(value);
    // console.log("*********value1**********");
    // console.log(value1);
    // console.log("*********deleting cookies**********");
    // //delete_cookie('user89');
    //deleteAllCookies();
    // console.log("************cookie at last************");
    // console.log(document.cookie);

    //console.log(this.cookie.get("uid"));
    //console.log("*********cookie********");
      //console.log( this.uName)
  }
  getSelecteditem() {
    this.radioSel = ITEMS.find(Item => Item.value === this.radioSelected);
    this.radioSelectedString = JSON.stringify(this.radioSel);
    //console.log(this.radioSel.id);
  }

  onItemChange(item) {
    this.getSelecteditem();

  }
  ngAfterViewInit() {
    if (this.apiService.checkUserLoggedIn() == true) {
      //this.RatingModal.show();
    }
  }
  bookId: number;
  bookingDone() {
    let getDATA = { "Customer": this.user.id, "status": 2 }
    this.httpClient.post(this.apiService.getBookingBYquery, getDATA)
      .subscribe(
        (compdata_detail: any) => {
          if (this.debugData) {
            console.log("user rating Data");
            console.log(compdata_detail);
          }
          this.getCompDataDetail = compdata_detail;
          console.log(this.getCompDataDetail.length);
          for (let i = 0; i <= this.getCompDataDetail.length; i++) {
            if (this.getCompDataDetail[i].rating == 0) {
              this.bookId = this.getCompDataDetail[i].id;
              console.log(this.bookId);
              this.RatingModal.show();
            }
          }
        }
      )
  }

  submitUserRating(comment) {
    let getRateData = { 'rating': this.radioSel.id, 'comments': comment, 'booking': this.bookId };
    console.log(getRateData);
    this.httpClient.post(this.apiService.userRating, getRateData)
      .subscribe(
        (rate_detail: any) => {
          if (this.debugData) {
            console.log("user rating data")
            console.log(rate_detail)
          }
          this.getCompDataDetail = rate_detail;
          console.log(this.getCompDataDetail);
        },
        (err) => {
          this.ratingErrMsg = "Some error occured. Please try again";
        });

  }
  initCustData() {
    if (this.apiService.checkUserLoggedIn() == true) {
      let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
      this.httpClient.get(urrr)
        .subscribe(
          data => this.intilizeComponent(data),
          error => this.showError(error)
        );
    } else {
      this.buttonText = "Login/Signup";
      if (this.debugData == true) {
        //console.log("User Not Logged In. Please login!")
      }
    }
  }


  intilizeComponent(data) {
    if (this.debugData == true) {
      //console.log("Customer already logged in");
      //console.log(data);
    }
    this.user = data;
    this.buttonText = "Hi " + this.user.fName;
    if (this.showPopup == true) {
      this.showPopup = true;
      this.bookingDone();
      console.log("loading")
    }
    else if (this.showPopup == false) {
      //this.showPopup =false;
      this.RatingModal.hide();
    }
    //console.log("popup");
   // console.log(this.showPopup)
  }

  closePopup() {
    this.showPopup = false;
    //console.log(this.showPopup);
    this.RatingModal.hide();
  }
  checkUserLoginStatus(): boolean {
    if (this.apiService.checkUserLoggedIn() == true) {
      //this.buttonText ="Hi " + this.user.fName;this.uName
      this.buttonText ="Hi " + this.uName;
      return true;
      
    } else {
      this.buttonText = "Login/Signup";
      return false;
    }
  }

  showError(msg) {
    this.warn("Some Error Occured please try again");
  }
  showPopup: boolean = false;
  public userId;
  public uName;
  // <!-- Start of sign in function -->
  public onFormLogin({ value, valid }: { value: signinUsrObj, valid: boolean }) {
    this.userSigninData = value;
    if (this.debugData) {
      console.log("Sign In Function data")
      console.log(this.userSigninData);
      console.log(this.apiService.LoginURL, this.userSigninData); 
    } 
    console.log(this.apiService.LoginURL, this.userSigninData,{
      withCredentials: true});
    this.httpClient.post(this.apiService.LoginURL, this.userSigninData)
      .subscribe((data: any) => {
        if (this.debugData == true) {
          // console.log("Customer Login API data");
          //console.log(data);
        }
        if (data.success == "true") {
          console.log("data.customer.user");
          console.log(data.customer.user);
          setCookie(data.customer.user);

          if (this.debugData == true) {
            //console.log("Customer id : " + data.customer.id);
            //console.log("Customer Name : " + data.customer.fName);
          }
         
          // this.userId = data.user_id;
          // console.log(this.userId);
          this.SignInmsg = "Sign In Sucessfull";
          this.storage.set('custDD', data.customer.id);
          this.storage.set('Name', data.customer.fName);
          console.log(data.customer.id)
          this.uName = data.customer.fName;
          // this.storage.set('uid',data.user_id);
          //this.cookie.set("uid",data.customer.id);
          // this.cookie.set("domain",".dev-on-track.co.in");
          // this.cookie.set("path","/");
          // this.cookie.set("uid",data.customer.id);
          // console.log("**********cookie uid***********");
          // console.log(this.cookie.get("uid"));
          
          // this.showPopup = true;
          // console.log(this.showPopup);
          // this.bookingDone();
          // this.storage.set('rateValue', this.showPopup);
          this.buttonText = "Hi " + data.customer.fName;
          this.initCustData();
          this.basicModal.hide();
          this.showPopup = true;
          console.log(this.showPopup);
          this.bookingDone();
          this.storage.set('rateValue', this.showPopup);
      
          this.form.reset();
          
          //this.refresh();
          // window.location.href="https://on-track.in/";
        } else {
          // this.success("Login failed");
          this.SignInmsg = " Sign in failed try again";
        }
      });
  }

  public cookieLogin(user) {

    console.log("**********in cookieLogin***********");
    let userValue = { 'user': user }
    this.httpClient.post(this.apiService.cookieLoginURL, userValue)
      .subscribe((data: any) => {
      
        if (data.success == "true") {
          if (this.debugData == true) {
            //console.log("Customer id : " + data.customer.id);
            //console.log("Customer Name : " + data.customer.fName);
          }
         
          // this.userId = data.user_id;
          // console.log(this.userId);
          this.SignInmsg = "Sign In Sucessfull";
          this.storage.set('custDD', data.customer.id);
          this.storage.set('Name', data.customer.fName);
          console.log(data.customer.id)
          this.uName = data.customer.fName;
         // this.storage.set('uid',data.user_id);
          //this.cookie.set("uid",data.customer.id);
          // this.cookie.set("domain",".dev-on-track.co.in");
          // this.cookie.set("path","/");
          // this.cookie.set("uid",data.customer.id);
          // console.log("**********cookie uid***********");
          // console.log(this.cookie.get("uid"));
          
          // this.showPopup = true;
          // console.log(this.showPopup);
          // this.bookingDone();
          // this.storage.set('rateValue', this.showPopup);
          this.buttonText = "Hi " + data.customer.fName;
          this.initCustData();
          this.basicModal.hide();
          this.showPopup = true;
          console.log(this.showPopup);
         // this.bookingDone();
          this.storage.set('rateValue', this.showPopup);
      
         // this.form.reset();
          
         
          //this.refresh();
          // window.location.href="https://on-track.in/";
        } else {
          // this.success("Login failed");
          this.SignInmsg = " Sign in failed try again";
        }
        
      });
  }
  // <!-- End of sign in function -->

  // resetFormData(loginForm: NgForm)
  // {
  //   loginForm.reset();
  //   console.log("clear");
  //   this.initCustData();
  //   this.SignInmsg="Please Login";
  // }

  genderNow: number = 1; // 1 for male and 0 for female , by default keep it as male
  changeGender(valueGender: number) {
    this.genderNow = valueGender;
    if (this.debugData) {
      console.log("Selected gender is ");
      console.log(this.genderNow);
    }
  }

  // <!-- Start of sign up function -->
  public onFormSubmit({ value, valid }: { value: signUpUserObj, valid: boolean }) {
    this.userSignUpData = value;
    this.userSignUpData.signUpType = "generic";
    this.userSignUpData.gender = this.genderNow;
    if (this.debugData) { 
      console.log("User SignUp Data");
      console.log(this.userSignUpData);
    }
    this.httpClient.post(this.apiService.signupURL, this.userSignUpData)
      .subscribe(
        (dataSignup: any) => {
          if (this.debugData) {
            console.log("signup form function api data");
            console.log(dataSignup);
          }
          if (dataSignup.status == true) {
            this.SignUpmsg = "Signup Successfully";
            dataSignup.obj.gender = this.genderNow;
            //console.log(dataSignup.obj);
            this.user = dataSignup.obj;
            this.initCustData();
           // console.log("HelloDDDDD");
           // console.log(this.user);
            this.storage.set('custDD', this.user.id);
            this.storage.set('Name', this.user.fName);
            this.buttonText = this.user.fName;
            this.OTPModal.show();
          } else {
            this.SignUpmsg = "Some Error Occured Please try again";
          }
        },
        (err) => {
          let errorD = err.error.message;
          if (errorD.indexOf("mobile") != -1) {
            this.SignUpmsg = "Mobile number already exist";
          } else if (errorD.indexOf("email") != -1) {
            this.SignUpmsg = "Email address already exist";
          }
        });
  }
  // <!-- end of sign up function -->

  // <!-- start of OTP verify function  -->
  verifyOtpN(otpToVerify) {
    let postData = { 'mobile': this.user.mobile, 'otp': otpToVerify }
    if (this.debugData) {
      console.log("very otp json data is ")
      console.log(postData);
    }
    this.httpClient.post(this.apiService.verifyOTP_URL, postData)
      .subscribe(
        (detail: any) => {
          if (this.debugData) {
            console.log("very otp function API Data ")
            console.log(detail);
          }
          if (detail.status == true) {
            if (this.debugData) {
              console.log("Success OTP Verified")
            }
            this.user = detail.obj;
            this.otpErrorMsg = "OTP Verified";
            this.refresh();
          } else {
            if (this.debugData) {
              console.log(" OTP not Verified")
            }
            this.otpErrorMsg = "Incorrect OTP";
          }
        }
      )
  }
  // <!-- end of OTP verify function  -->

  


  // <!-- Start of OTP send function  -->
  sendOtpN(mobileNumber, custId) {
    let postData = { 'mobile': mobileNumber, 'id': custId };
    this.httpClient.post(this.apiService.sendOtpURL, postData)
      .subscribe(
        (detail: any) => {
          if (this.debugData) {
            console.log("Send OTP Api data");
            console.log(detail);
          }
          if (detail.status == true) {
            return true;
          } else {
            return false;
          }
        }
      )
  }
  // <!-- end of OTP send function  -->

  // <!-- start of OTP Resend function  -->
  resendOtpNow() {
    if (this.apiService.checkUserLoggedIn() == true) {
      let postData = { 'mobile': this.user.mobile };
      this.httpClient.post(this.apiService.resendURL, postData)
        .subscribe(
          (detail: any) => {
            if (this.debugData) {
              console.log("resend otp function API data");
              console.log(detail);
            }
            if (detail.status == true) {
              this.otpErrorMsg = "OTP sent"
            } else {
              this.otpErrorMsg = "OTP sending fail"
            }
          },
          (err) => {
            this.otpErrorMsg = "Some error occured. Please try again."
          });
    } else {
      this.warn("Please Login");
    }
  }
  // <!-- end of OTP Resend function  -->

  refresh(): void {
    window.location.reload();
  }

  logout() {
    deleteAllCookies();
    this.storage.remove('custDD');
    this.apiService.saveInLocalData(this.user.id, null);
    this.apiService.saveInLocalData(this.user.fName, null);
    //this.showPopup = false;
    this.storage.set('rateValue', null);
    this.buttonText = "Login/Signup";
    this.router.navigate(['/model']);
    this.form.reset();
    this.refresh();
//  console.log(this.userId);
//  console.log(this.apiService.postsURL + "weblogout?user_id="+this.apiService.getFromLocalData('uid'));
//   this.httpClient.get(this.apiService.postsURL + "weblogout?user_id="+this.apiService.getFromLocalData('uid'))
//       .subscribe((data: any) => {
//     console.log(data);
 
//   })
//   this.apiService.saveInLocalData(this.user.id, null);
//   this.apiService.saveInLocalData(this.user.fName, null);
//   this.apiService.saveInLocalData('custDD', null);
//   this.apiService.saveInLocalData('Name', null);
//   //this.apiService.saveInLocalData('uid',null);
//   this.buttonText = "Login/Signup";
//   this.router.navigate(['/model']);
//  //this.refresh();
  }

  // <!-- Start of reset password link function -->
  resetPwd(emailVal: string) {
    let getResetData = { "email": emailVal };
    this.httpClient.post(this.apiService.postsURL + 'resetPassword', getResetData)
      .subscribe(
        (reset: any) => {
          if (this.debugData) {
            console.log("Email Reset function");
            console.log(reset);
          }
          if (reset.status == true) {
            this.emailResetMsg = "Link sent successfully";
            this.forgotPasswordModal.hide();
            return true;
          } else {
            this.emailResetMsg = "Please enter valid email id";
            return false;
          }
        },
        (err) => {
          this.emailResetMsg = "Some error occured. Please try again."
        });
  }
  // <!-- End of reset password link function -->

  success(message: string) {
    this.alertService.success(message);
  }

  error(message: string) {
    this.alertService.error(message);
  }

  info(message: string) {
    this.alertService.info(message);
  }

  warn(message: string) {
    this.alertService.warn(message);
  }

  clear() {
    this.alertService.clear();
  }

}




// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/header/header.component.ts